import {useState,useEffect} from "react";
import { Link ,useLocation } from "react-router-dom";
import CtntTop5InqApi from "Apis/CtntTop5InqApi";
import GameSvcCtntPstdLstInqApi from "Apis/GameSvcCtntLstInqApi";
import MembQnaLstApi from "Apis/MembQnaLstApi";
import Pagination from "react-js-pagination";
import UseLangLstQuery from "Apis/LangTxtInqApi";
import MgpStore from "Stores/Store";
import "Assets/css/Ctnt.css";
import "Assets/css/Cs.css";
import MembGameRelLstApi from "Apis/MembGameRelLstApi";
import { Helmet } from "react-helmet-async";
const QnaLstUi = ({gameSvcCd,ctntCtgrCd,ctntCtgrCdName,LstType}:any) => {
    const {data: langData}:any = UseLangLstQuery();
    const [pageState, setPageState] = useState(1);
    const [onePageSizeState,setOnePageSizeState] = useState();
    const [totPstdCntState,setTotPstdCntState] = useState(1)
    const location= useLocation();  
        const serchParamsFunc = () => {
            return new URLSearchParams(location.search);
        }
        let query =serchParamsFunc();
        let getGameSvcCd = query.get("gameSvcCd");
        let getctntKindCd = query.get("ctntKindCd");
        if(getGameSvcCd !=null){
            gameSvcCd = getGameSvcCd;
            ctntCtgrCd = getctntKindCd;
        }
    
        if(gameSvcCd ==null) {
            gameSvcCd = location.state?.gameSvcCd;
        }
        if(ctntCtgrCd ==null) {
            ctntCtgrCd = location.state?.ctntKindCd;
        }
    const [ctntCtxtState,setCtntCtxtState] = useState<any>();
    const [ctntKindCdState,setCtntKindCdState] = useState<any>();
    const [membGameYrelLstState,setMembGameYrelLstState] = useState<any>();
    const [selectedSvcNmState,setSelectedSvcNmState] = useState<any>();
    const [gameYrelLstSelectMenuStates,setGameYrelLstSelectMenuStates] = useState(false);
    const [selectedSvcCdState,setSelectedSvcCdState] = useState("");
    
    useEffect(()=>{
        MembGameRelLstApi().then((resp)=>{
            setMembGameYrelLstState(resp.yrelLst);
            
            // URL 파라미터에서 gameSvcCd 확인
            const urlGameSvcCd = gameSvcCd || "MGP";
            
            // 해당 게임 정보 찾기
            const selectedGame = resp.yrelLst.find((game: any) => game.gameSvcCd === urlGameSvcCd);
            
            if (selectedGame) {
                // URL로 지정된 게임이 존재하는 경우
                setSelectedSvcCdState(urlGameSvcCd);
                setSelectedSvcNmState(selectedGame.gameNm);
            } else if (urlGameSvcCd === "MGP") {
                // MGP (전체) 선택
                setSelectedSvcCdState("MGP");
                setSelectedSvcNmState(langData?.MYPAGE_SELT_VAL_ALL_DESC_00 || "전체");
            } else {
                // 지정된 게임이 없으면 기본값 MGP
                setSelectedSvcCdState("MGP");
                setSelectedSvcNmState(langData?.MYPAGE_SELT_VAL_ALL_DESC_00 || "전체");
            }
            
            // 선택된 게임의 QnA 목록 불러오기
            MembQnaLstApi(urlGameSvcCd, pageState, "").then((resp)=>{
                setCtntCtxtState(resp.apiBody.qnaLst);
                setPageState(resp.apiBody.nowPageNo);
                setOnePageSizeState(resp.apiBody.onePageSize);
                setTotPstdCntState(resp.apiBody.totCnt);
            });
        });
    }, [MgpStore.getState().LangSetState.Lang, gameSvcCd]);
    const GameYrelLstSelectMenuToggle = () => {
        setGameYrelLstSelectMenuStates(gameYrelLstSelectMenuStates => !gameYrelLstSelectMenuStates);
    }
    function returnOfIndex(value:string, membGameYrelLstState:any){
        let index;
        for(var i=0; i<membGameYrelLstState.length; i++){
            if(membGameYrelLstState[i].gameNm.indexOf(value) != -1){
                index=i;
            }
        }
        return index;
    }
    const SelectValueSetFunc =(value:string) => {
        var returnValue = returnOfIndex(value,membGameYrelLstState)
        if(returnValue == undefined) {
            returnValue =0;
        }
        let selectedGameSvcCd = membGameYrelLstState[returnValue].gameSvcCd;
        let selectedGameNm = membGameYrelLstState[returnValue].gameNm;

        setSelectedSvcCdState(selectedGameSvcCd);
        setSelectedSvcNmState(selectedGameNm);
        if(value === "MGP") {
            setSelectedSvcCdState("MGP");
            setSelectedSvcNmState(langData?.MYPAGE_SELT_VAL_ALL_DESC_00 || "전체");
            selectedGameSvcCd = "MGP";
            selectedGameNm = langData?.MYPAGE_SELT_VAL_ALL_DESC_00 || "전체";
        }
        GameYrelLstSelectMenuToggle();
        
        // 선택한 게임의 QnA 목록 불러오기
        MembQnaLstApi(selectedGameSvcCd, pageState, "").then((resp) => {
            setCtntCtxtState(resp.apiBody.qnaLst);
            setPageState(resp.apiBody.nowPageNo);
            setOnePageSizeState(resp.apiBody.onePageSize);
            setTotPstdCntState(resp.apiBody.totCnt);
        });
        
        // setselectedSvcCdState(membGameYrelLstState[returnValue].gameSvcCd),
        // setselectedSvcNmState(membGameYrelLstState[returnValue].gameNm),
        //  setMembGameSvcMny(membGameYrelLstState[returnValue].totMny)
    }
    const handlePageChange = (pageState:any) => {
        setPageState(pageState);
        MembQnaLstApi(selectedSvcCdState,pageState,"").then((resp)=>{
            setCtntCtxtState(resp.apiBody.qnaLst);
            setPageState(resp.apiBody.nowPageNo)
            setOnePageSizeState(resp.apiBody.onePageSize)
            setTotPstdCntState(resp.apiBody.totCnt)
        })
      };
    const [ctntCtgrCdCd,setctntCtgrCdCd] = useState(ctntCtgrCd);
    return(
        <>
        <Helmet>
            <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.MYPAGE_MAIN_QNA_LST_BTN_00}`}</title>    
        </Helmet>
            <div className="container1300 BgW pb200">
                <div className="myPageSubTitlWrap">
                    <p className="myPageCtxtTitl">{langData&&langData.MYPAGE_MAIN_QNA_LST_BTN_00}</p>
                </div>
                <div  className="mypageSubCtgrMenuWrap">
                    <div>
                        <ul className="ctntCtgrMenu">
                            <li>
                                <div 
                                    className="ctxtLiTitl relative"
                                    onBlur={() => setGameYrelLstSelectMenuStates(false)}
                                    tabIndex={0}
                                >
                                    <p className={gameYrelLstSelectMenuStates?'gameYrelSelectTitl active':"gameYrelSelectTitl"} onClick={() => GameYrelLstSelectMenuToggle()}> {selectedSvcNmState&&selectedSvcNmState} </p>
                                    <div className={gameYrelLstSelectMenuStates?'gameYrelWrap active':"gameYrelWrap"}>
                                        <ul style={{display:"block"}}>
                                            <li onClick={()=>SelectValueSetFunc("MGP")}>
                                                {langData&&langData.MYPAGE_SELT_VAL_ALL_DESC_00}
                                            </li>
                                            {
                                                membGameYrelLstState&&membGameYrelLstState.map((key:any) => (
                                                    // <li onClick={()=>SelectValueSetFunc(key.gameNm)}>
                                                    //     {key.gameNm}
                                                    // </li>
                                                    <li onClick={()=>SelectValueSetFunc(key.gameNm)}>
                                                        {key.gameNm}
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </li>
                            {/* <li className={ctntCtgrCd == "QNA"?"active":""}>
                                <Link to={`/cs/QnaLst?gameSvcCd=${gameSvcCd}&ctntKindCd=QNA`}>
                                    <p>{langData&&langData.CS_MAIN_CTGR_QNA_BTN_00}</p>
                                </Link>
                            </li> */}
                        </ul>
                    </div>
                </div>
                <div className="ctntLstWrap ctntPstdLstWrap qnaLstWrap">
                    <div className={`${ctntCtgrCdCd}TitlWrap ctntLstTitlWrap`}>
                        <h2>{ctntCtgrCdName}</h2>
                    </div>
                    <div className="myGameSvcMnyCtxtWrap">
                        <div className="myGameSvcMnydpstOdrLstWrap">
                            <ul>
                                <li className="lstTItlWrap col602020 moNone">
                                    <p className="ctntTitlTxt textL">{langData&&langData.MYPAGE_MAIN_CTGR_QNA_BTN_00}</p>
                                    <p>{langData&&langData.MYPAGE_QNA_REG_DTIME_LBL_00}</p>
                                    <p>{langData&&langData.MYPAGE_QNA_RPL_YN_LBL_00}</p>
                                </li>
                                {ctntCtxtState&&ctntCtxtState.length != 0  ? 
                                    <>
                                    {ctntCtxtState&&ctntCtxtState.map((key:any) => (
                                        <li key={key.qnaSno} className="qnaNtfyRow">
                                            <Link className="qnaNtfyRowLink" to={`/MyPage/QnaCtxt?gameSvcCd=${key.gameSvcCd}&ctntCtgrCd=${ctntCtgrCdCd}&qnaSno=${key.qnaSno}`}>
                                                <p className="ctntTitlTxt textL">{key.qnaTitl}</p>
                                                <p className="moNone">{key.crtdDtime}</p>
                                                {key.qnaKindCd === "Q" ?
                                                    <p className={`rplCol${key.rplYn}`}>{langData&&langData[`MYPAGE_QNA_RPL_${key.rplYn}_LBL_00`]}</p>
                                                    :
                                                    <p>{langData&&langData[`MYPAGE_QNA_RPL_A_LBL_00`]}</p>
                                                }
                                            </Link>
                                        </li>
                                    ))}
                                    </>
                                    :
                                    <li className="noDataLi"><p>{langData&&langData.GLB_NO_DATA_LBL_00}</p></li>
                                }
                            </ul>
                            {ctntCtxtState&&ctntCtxtState.length != 0  ? 
                                <div className="ctntPageWrap">
                                    <Pagination
                                        activePage={pageState}
                                        itemsCountPerPage={onePageSizeState}
                                        totalItemsCount={totPstdCntState}
                                        pageRangeDisplayed={5}
                                        firstPageText={""}
                                        linkClassFirst={"pagenationBtn pagenationFirstBtn"}
                                        prevPageText={""}
                                        linkClassPrev={"pagenationBtn pagenationPrevBtn"}
                                        nextPageText={""}
                                        linkClassNext={"pagenationBtn pagenationNextBtn"}
                                        lastPageText={""}
                                        linkClassLast={"pagenationBtn pagenationLastBtn"}
                                        onChange={handlePageChange}
                                    />
                                </div>
                                :
                                <></>
                            }
                        </div>
                    </div>
                    <div className="qnaBtnWrap qnaLstBtnWrap">
                        <Link to={`/MyPage/QnaWrite`}>
                            <p>{langData&&langData.MYPAGE_QNA_MAIN_REG_BTN_00}</p>
                        </Link>
                    </div>
                </div>
            </div>
        </>
    )
}
export default QnaLstUi;